import {Injectable} from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpResponse,
    HttpErrorResponse
} from '@angular/common/http';
import {GlobalService} from '../../service/global.service';
import 'rxjs/add/operator/do';
import {Observable} from 'rxjs/Rx';
import {Router} from '@angular/router';

@Injectable()
export class NotAuthorizedInterceptor implements HttpInterceptor {

    constructor(public globalService: GlobalService, private router: Router) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request).do((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
                var dataAtual = new Date();
                if ((dataAtual.getTime() - this.globalService.timeRefresh.getTime()) / 1000 > 600) {
                    if (this.globalService.usuario == null) {
                        this.globalService.renovarToken(localStorage.getItem('refresh_token')).subscribe();
                    } else {
                        this.globalService.renovarToken(this.globalService.usuario.refresh_token).subscribe();
                    }
                    this.globalService.timeRefresh = dataAtual;
                }
            }
        }, (err: any) => {
            if (err instanceof HttpErrorResponse) {
                if (err.status == 401) {
                    if (this.router.url != '/' && this.router.url != '/login') {
                        this.globalService.loading = false;
                        this.globalService.autenticado = false;
                        this.globalService.abrirModalLogin();
                    }
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/not-authorized-interceptor.ts